// Vendor imports
const PropTypes = require('prop-types')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

function InlineFrame(props) {
  return tag('iframe', props)
}

InlineFrame.propTypes = {
  allowFullScreen: PropTypes.bool,
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  frameBorder: PropTypes.string,
  height: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string
}

InlineFrame.defaultProps = {
  allowFullScreen: true,
  frameBorder: '0',
  height: '100%',
  width: '100%'
}

module.exports = InlineFrame
